import { DateTime } from "luxon";
import type { Policy } from "@/lib/auth/AccessPolicy";
import { salonNow } from "@/lib/time";

/**
 * Compute the earliest allowed calendar date according to policy, in salon TZ.
 * -1 → DateTime.fromMillis(0) (no limit)
 *  0 → today (future only)
 *  N>0 → today minus N days
 */
export function earliestAllowedDate(policy: Policy): DateTime {
  const today = salonNow().startOf("day");
  const n = policy.timetable.lastDaysCount;
  if (n === -1) return DateTime.fromMillis(0);
  if (n === 0) return today;
  if (typeof n === "number" && n > 0) return today.minus({ days: n });
  return today; // safe default
}

/** Convenience guard: is the given date before the earliest allowed? */
export function isDateBeforeEarliest(d: DateTime, policy: Policy): boolean {
  return d.startOf("day") < earliestAllowedDate(policy);
}
